import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowDown } from '@fortawesome/free-solid-svg-icons'

function ScrollBottom() {
  return (
    <div>
      <FontAwesomeIcon
        id='scrolltobottom'
        onClick={() => { window.scrollTo(0, document.getElementsByTagName('body')[0].offsetHeight) }}
        icon={faArrowDown} />
    </div>
  );
}

export default ScrollBottom;
